import {
  getCurrentOrganization,
  createOrganization,
} from "@ckweb/ckfetch/connectables/organization";
import { getIndustryLookupList } from "@ckweb/ckfetch/connectables/setup";

export function useGetIndustries() {
  return useSafeLocalFetch("getIndustryLookupList", getIndustryLookupList, {
    fallback: [],
    customFetchOpts: {
      allowAnonymous: true,
      beforeRequest: async (request) => {
        request.headers.append("Authorization", "");
      },
    },
  });
}

export function useGetCurrentOrganization() {
  return useSafeLocalFetch("getCurrentOrganization", getCurrentOrganization, {
    fallback: (organization) => organization as OrganizationInfo,
    showGlobalLoadingIndicator: true,
  });
}

export function useCreateOrganization() {
  return useSafeLocalFetch("createOrganization", createOrganization, {
    fetchType: "mutate",
    showGlobalLoadingIndicator: true,
    enableGlobalNotifications: true,
    customFetchOpts: {
      allowAnonymous: true,
    },
  });
}
